import { MapContext } from 'os-elements';
import { useContext, useEffect } from 'react';

const debounce = (fn) => {
    let handle;
    return (...args) => {
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(() => {
            fn(...args);
        });
    };
};

/**
 * Registers a debounced callback on the map's `moveend` event and calls it
 * immediately on mount. Cleans up the listener on unmount.
 *
 * @param {Function} callback - Function to invoke on moveend (and on mount).
 * @param {Array} deps - Extra dependencies for the effect (callback inputs).
 */
export const useMapMoveEnd = (callback, deps = []) => {
    const { map } = useContext(MapContext);

    useEffect(() => {
        if (!map) {
            return;
        }

        const debouncedCallback = debounce(callback);
        const listener = () => debouncedCallback(map);

        callback(map);
        map.on('moveend', listener);

        return () => {
            map.un('moveend', listener);
        };
    }, [map, ...deps]);
};
